import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule } from 'app/core/services/i18n/i18n.module';

import { SidebarNavComponent } from './sidebar-nav.component';
import { SidebarNavSectionComponent } from './sidebar-nav-section.component';
import { SidebarNavSectionLinkComponent } from './sidebar-nav-section-link.component';

@NgModule({
  declarations: [
    SidebarNavComponent,
    SidebarNavSectionComponent,
    SidebarNavSectionLinkComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule
  ],
  exports: [
    SidebarNavComponent,
    SidebarNavSectionComponent,
    SidebarNavSectionLinkComponent
  ]
})
export class SidebarNavModule {}
